
import Modal from 'react-modal';
import { handleKeyDown, isMobile } from '../../utils/utils';
import useAppState from '../../context/AppContext';

type AdditionalOptionModalProps = {
  isOpen: boolean;
  onCloseModal: () => void;   
  };
  
  
  
  export default function AdditionalOptionModal({
    isOpen = false, onCloseModal 
  }: AdditionalOptionModalProps) {
    Modal.setAppElement("#root");
    const {
        state: { additionals },
      } = useAppState();

    const pageWidth = window.innerWidth * 0.9 < 850 ?  window.innerWidth * 0.9 : 850;

    const style = {
      maxWidth: pageWidth,
      display: 'flex',
      flexDirection: 'column',
    };

    const contenu = () => {
        return (
            <div className='bg-blanc'>
                <div className='header-reviewer bg-noir p-md blanc'>
                    <p>Vos options de couverture complémentaire&nbsp; : </p>
                    <i className="fz-xl" onClick={onCloseModal} role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>x</i>
                </div>
                <div id={"viewerZone"} style={{ overflow: 'auto', flex: 1 }}>
                <table className="simple-table striped" width="100%">
                    <thead>
                        <tr>
                            <th>Options</th>
                            <th>Montant</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        additionals.map((option, i) => <tr key={i}>
                            <td>{option.type} - {option.name}</td>
                            <td>{option.amount} € /mois</td>
                        </tr>)
                    }
                    </tbody>
                    <tfoot>
                      <tr className='bg-menthe'>
                        <td><strong>Total</strong></td>
                        <td><strong>{additionals.reduce((acc, i) => acc + i.amount, 0)} € / mois</strong></td>
                      </tr>
                    </tfoot>
                </table>
                </div>
            </div>
        )
    }

    if (isMobile()) {
      return (
        <div className='preview-mobile'>
          {contenu()}
        </div>
      )
    }

    return (
      <Modal isOpen={isOpen} onRequestClose={onCloseModal}>
        <div className="modale open">
          <div className="modale--content">
            <div className="modale--content--template">
              <div className="modale--main-width-entreprise shadow-bleu bg-noir-35" style={style as React.CSSProperties} >
                {contenu()}
                
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }